import { createContext } from 'react';
import type { Session, SupabaseClient, User } from '@supabase/supabase-js';

export interface AuthState {
  client: SupabaseClient | null;
  configured: boolean;
  loading: boolean;
  session: Session | null;
  user: User | null;
  signIn: (email: string, password: string) => Promise<string | null>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);
